module.exports = __webpack_public_path__ + "static/media/edit-icon.58910663.svg";